module.exports = __webpack_public_path__ + "static/media/tiger.36076082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/tiger.svg
// module id = 624
// module chunks = 6